<template>
	<Panel :title="'Ticket'" :icon="'file-alt'">
		<div class="panel-block">
			<div class="recibo-parlay is-relative">
				<img src="~@/assets/img/recibo.png" alt="">
				<div class="info-recibo">
					<div class="privada" v-if="quiniela.privada && !puedeVer">
						<p class="has-text-centered"><font-awesome-icon icon="lock"/> Esta quiniela es privada</p>
					</div>
					<div v-if="!quiniela.privada || puedeVer">
						<div class="partido" v-for="partido in quiniela.partidos" :key="partido.id">
							<span class="equipo" :class="{ 'mal' : (partido.estado == 2 && !prediccionAcertada(partido)) }">{{ partido.id }} {{ returnEleccion(partido) }}</span>
							<span class="momio is-pulled-right is-success">{{ getPrediccion(partido.id).momio.toFixed(2) }}</span>
						</div>
					</div>

					<div class="resumen has-text-centered">
						<div class="apuesta">Apuesta: <span>{{ Number(quiniela.apuesta).toLocaleString() }}</span></div>
						<div class="a-ganar">A ganar: <span>{{ Number(quiniela.a_ganar).toLocaleString() }} <font-awesome-icon icon="coins"/></span></div>
					</div>
				</div>
			</div>
		</div>
	</Panel>
</template>

<script>
	import Panel from '@/components/Panel'
	import { mapState, mapGetters } from 'vuex'

	export default {
		components: { Panel },
		props: {
			quiniela: {
				type: Object,
				required: true
			}
		},
		name: 'TicketParlay',

		data() {
			return {

			};
		},
		methods:{
			getPrediccion(partidoId){
				return this.quiniela.jugadores[0].predicciones.find(prediccion => prediccion.id_partido === partidoId);
			},
			returnEleccion(partido){
				let eleccion = ''
				let prediccion = this.getPrediccion(partido.id)
				let local,visitante

				switch(prediccion.resultado){
					case 'L':
						eleccion = partido.equipo_local.nombre;
					break;
					case 'V':
						eleccion = partido.equipo_visitante.nombre;
					break;
					case 'E':
						local = partido.equipo_local.nombre.substring(0,10) + ((partido.equipo_local.nombre.length) > 10 ? '...':'')
						visitante = partido.equipo_visitante.nombre.substring(0,10) + ((partido.equipo_visitante.nombre.length > 10) ? '...':'')
						eleccion = local + ' / ' + visitante;
					break;

				}

				return eleccion
			},
			prediccionAcertada(partido){
				let prediccion = this.getPrediccion(partido.id)

				return prediccion.acerto;
			}
		},
		computed: {
			puedeVer(){
				if (this.loggedIn && this.user.user.id === this.quiniela.creador.id) {
					return true
				}

				return false
			},
			...mapState('user',['user']),
			...mapGetters(['loggedIn'])
		}
	};
</script>

<style lang="css" scoped>
.recibo-parlay{
	margin: 0 auto;
}
.recibo-parlay img{
	width: 100%;
	min-width: 260px;
	max-width: 300px;
}
div.info-recibo{
	position: absolute;width: 77%;
	top: 96px;
	left: 35px;
	font-size: 0.7em;
}
.info-recibo .partido{
	margin-bottom: 0.5em;
}
.momio{
	color: #137936;
	font-weight: 700;
	font-size: 1.1em;
}
.mal{
	text-decoration: line-through;
}
.resumen{
	font-size: 1rem;
}
.resumen div > span{
	color: #137936;
}
.privada{
	margin: 3em auto;
	font-size: 1.3em;
}
</style>
